import NestedSearchComponent from "../../components/nestedSearchComponent/nestedSearchComponent";

export const Search = () => <NestedSearchComponent />
